import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BusinessAuthService } from '../services/business-auth.service';
import { environment } from '../../environments/environment';

function apiBase(): string {
  return environment.apiUrl.replace(/\/$/, '');
}

function isBusinessApiRequest(url: string): boolean {
  const base = apiBase();
  return url.startsWith(base) || url.startsWith(`${base}/`);
}

/** Sin Authorization ni headers de contexto (solo login / reset password). */
function skipAuthorization(url: string): boolean {
  const path = url.replace(apiBase(), '');
  if (path.includes('/auth/business-login')) return true;
  if (path.includes('/auth/business-master-login')) return true;
  if (path.includes('/auth/business/forgot-password')) return true;
  if (path.includes('/auth/business/validate-reset-token')) return true;
  if (path.includes('/auth/business/reset-password')) return true;
  return false;
}

/** GET /business/master/companies: Bearer sí, X-Business-Account-Id no. */
function skipActiveBusinessAccountHeader(url: string): boolean {
  const path = url.replace(apiBase(), '');
  return path.includes('/business/master/companies');
}

/**
 * Añade Authorization y, para sesión maestra, X-Business-Account-Id en requests al API empresarial.
 */
export const businessContextInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isBusinessApiRequest(req.url) || skipAuthorization(req.url)) {
    return next(req);
  }

  const auth = inject(BusinessAuthService);
  const token = auth.getToken()?.trim();
  if (!token) {
    return next(req);
  }

  let headers = req.headers.has('Authorization')
    ? req.headers
    : req.headers.set('Authorization', `Bearer ${token}`);

  if (
    auth.isMasterSession() &&
    !skipActiveBusinessAccountHeader(req.url)
  ) {
    const activeId = auth.getActiveBusinessAccountId()?.trim();
    if (activeId && !headers.has('X-Business-Account-Id')) {
      headers = headers.set('X-Business-Account-Id', activeId);
    }
  }

  return next(req.clone({ headers }));
};
